(function () {
  'use strict';
  const key = 'fcs-fitguide-shipping-destination-v1';
  const autoKey = 'fcs-fitguide-shipping-estimate-v1';
  const clearKey = 'fcs-fitguide-shipping-cleared-v1';
  let pageCleared = false;
  const autoTtl = 24 * 60 * 60 * 1000;
  const states = new Set('AL AK AZ AR CA CO CT DE DC FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY'.split(' '));
  const countries = new Set('AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(' '));
  function destinationFromResponse(data) {
    if (!data || data.success !== true || !countries.has(data.country_code)) return null;
    if (data.country_code !== 'US') return { country: data.country_code, province: 'OTHER' };
    return states.has(data.region_code) ? { country: 'US', province: data.region_code } : null;
  }
  function fresh(saved, duration) {
    return saved && Number.isFinite(saved.savedAt) && Date.now() >= saved.savedAt && Date.now() - saved.savedAt < duration;
  }
  const ttl = 7 * 24 * 60 * 60 * 1000;
  function shippingOffer(province) {
    const detail = 'Delivery options and timing confirmed at checkout';
    if (province === 'NC' || province === 'SC') return { headline: 'Shipping to ' + (province === 'NC' ? 'North Carolina' : 'South Carolina'), detail };
    if (province === 'OTHER') return { headline: 'Shipping options for your destination', detail };
    if (province) return { headline: 'Shipping to ' + province, detail };
    return { headline: 'Check your delivery options', detail };
  }
  if (typeof module === 'object' && module.exports) { module.exports = { shippingOffer, destinationFromResponse }; return; }
  function init(root) {
    if (root.dataset.fcsShippingReady) return;
    root.dataset.fcsShippingReady = 'true';
    const select = root.querySelector('[data-fcs-shipping-state]');
    const allowed = new Set(Array.from(select.options, option => option.value));
    let province = '';
    let source = 'unknown';
    let generation = 0;
    let controller;
    let suppressed = pageCleared;
    try { suppressed = suppressed || sessionStorage.getItem(clearKey) === '1'; } catch (_) {}
    try {
      const saved = JSON.parse(localStorage.getItem(key));
      if (fresh(saved, ttl) && saved.province && allowed.has(saved.province)) { province = saved.province; source = 'manual'; }
    } catch (_) { /* The banner still works when browser storage is unavailable. */ }
    if (!province && !suppressed) {
      try {
        const saved = JSON.parse(localStorage.getItem(autoKey));
        const destination = destinationFromResponse({ success: true, country_code: saved?.country, region_code: saved?.province });
        if (fresh(saved, autoTtl) && destination && destination.province === saved.province) { province = destination.province; source = 'estimated'; }
      } catch (_) {}
    }
    function render(announce) {
      select.value = province;
      root.dataset.fcsShippingProvince = province;
      root.dataset.fcsShippingCountry = states.has(province) ? 'US' : '';
      document.dispatchEvent(new CustomEvent('fcs:shipping-destination', { detail: states.has(province) ? { country: 'US', province, source } : null }));
      root.dataset.fcsShippingSource = source;
      const hint = root.querySelector('[data-fcs-shipping-estimate]');
      if (hint) { hint.hidden = source !== 'estimated'; hint.textContent = 'Location estimated from your connection. Change it if shipping elsewhere.'; }
      const offer = shippingOffer(province);
      const offerNode = root.querySelector('[data-fcs-shipping-offer]');
      offerNode.textContent = offer.headline + ' ';
      const detail = document.createElement('span'); detail.textContent = offer.detail; offerNode.appendChild(detail);
      const location = root.querySelector('[data-fcs-shipping-location]');
      location.textContent = !province ? 'Select state' : states.has(province) && !['NC','SC'].includes(province) ? province + ' · Change' : 'Change';
      location.title = source === 'estimated' ? 'Estimated location. Change your shipping destination.' : 'Change your shipping destination';
      if (announce) root.querySelector('[data-fcs-shipping-status]').textContent = offer.headline + '. ' + offer.detail;
    }
    root.querySelector('[data-fcs-shipping-form]').addEventListener('submit', function (event) {
      event.preventDefault();
      if (!select.value || !allowed.has(select.value)) return;
      generation++;
      controller?.abort();
      province = select.value; source = 'manual';
      try { localStorage.setItem(key, JSON.stringify({ province, savedAt: Date.now() })); } catch (_) {}
      render(true);
      root.querySelector('details').open = false;
      root.querySelector('summary').focus();
    });
    root.querySelector('[data-fcs-shipping-clear]').addEventListener('click', function () {
      generation++; controller?.abort();
      pageCleared = true; suppressed = true;
      province = ''; source = 'unknown';
      try { sessionStorage.setItem(clearKey, '1'); } catch (_) {}
      try { localStorage.removeItem(key); localStorage.removeItem(autoKey); } catch (_) {}
      render(true); select.focus();
    });
    render(false);
    if (!province && !suppressed && typeof fetch === 'function' && typeof AbortController === 'function') {
      const token = generation;
      controller = new AbortController();
      // Invalidate even if an implementation ignores abort. Never retry a failed lookup.
      const timer = setTimeout(() => { if (generation === token) generation++; controller.abort(); }, 2500);
      fetch('https://ipwho.is/?fields=success,country_code,region_code', { signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer' })
        .then(response => response.ok ? response.json() : null)
        .then(data => {
          if (generation !== token || source === 'manual' || suppressed || pageCleared) return;
          const destination = destinationFromResponse(data);
          if (!destination) return;
          province = destination.province; source = 'estimated';
          try { localStorage.setItem(autoKey, JSON.stringify({ ...destination, savedAt: Date.now() })); } catch (_) {}
          render(true);
        })
        .catch(() => { /* Neutral copy and the manual selector remain available. */ })
        .finally(() => clearTimeout(timer));
    }
  }
  function scan(scope) { scope.querySelectorAll('[data-fcs-shipping-destination]').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
